module.exports = __webpack_public_path__ + "img/1210 MK3 G.2cb2ddb2.png";